export default {
	'fiscal-year': 'fiscal year',
	'change-active-fiscal-year': 'Change active fiscal year',
	'confirm-changing-active-fiscal-year': 'Are you sure you want to change the active fiscal year?',
	'confirm-delete-fiscal-year': 'Are you sure you want to delete the fiscal year?'
}